import PortfolioContainer from "../containers/portfolio_container"

export default function Portfolio() {
    return <PortfolioContainer />
}
